// extracted by mini-css-extract-plugin
module.exports = {"card":"EventCardInteractionWrapper_card__HPjxE","is-past-event":"EventCardInteractionWrapper_is-past-event__9_pJJ"};